import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';
import { H3, LayoutSingleColumn, NamedLink, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import SectionFooter from '../PageBuilder/SectionBuilder/SectionFooter';

import css from './TermsOfServicePage.module.css';
import trademark from './unnamed.png';

// This "content-only" component can be used in modals etc.
export const TermsOfServiceContent = props => {
  return (
    <div className={css.root}>
      <H3>
        TERMS OF USE
      </H3>
      <p className={css.info}>
        This page (together with the documents referred to in it) tell you the terms of use on which you may make use of our website {" "}
        <NamedLink name="LandingPage">
          housesitmatch.com (our site)
        </NamedLink>
        , whether as a guest or a registered user. Please read these Terms of Use carefully before you start to use the site.
      </p>
      <p className={css.subtitle}>
        READ OUR HOUSESIT MATCH TERMS OF USE
      </p>
      <p className={css.info}>
        By using our site, you indicate that you accept these terms of use and that you agree to abide by them. If you do not agree to these terms of use, please refrain from using our site.
      </p>

      <p className={css.subtitleSmall}>
        INFORMATION ABOUT US
      </p>
      <p className={css.info}>
        <NamedLink name="LandingPage">
          Housesitmatch.com
        </NamedLink>
        {" "}is a site operated by HOUSESIT MATCH LIMITED (“We”). We are registered in England and Wales under company number 07892745 and have our registered office at 7 West Waye, High Wycombe, Buckinghamshire, HP13 5PT.
      </p>

      <p className={css.subtitleSmall}>
        ACCESSING OUR SITE
      </p>
      <p className={css.info}>
        Access to our site is permitted on a temporary basis, and we reserve the right to withdraw or amend the service we provide on our site without notice (see below). We will not be liable if for any reason our site is unavailable at any time or for any period.
      </p>
      <br />
      <p className={css.info}>
        From time to time, we may restrict access to some parts of our site, or our entire site, to users who have registered with us.
      </p>
      <br />
      <p className={css.info}>
        If you choose, or you are provided with, a user identification code, password or any other piece of information as part of our security procedures, you must treat such information as confidential, and you must not disclose it to any third party. We have the right to disable any user identification code or password, whether chosen by you or allocated by us, at any time, if in our opinion you have failed to comply with any of the provisions of these terms of use.
      </p>
      <br />
      <p className={css.info}>
        When using our site, you must comply with the provisions of our acceptable use policy. You are responsible for making all arrangements necessary for you to have access to our site. You are also responsible for ensuring that all persons who access our site through your internet connection are aware of these terms, and that they comply with them.
      </p>

      <p className={css.subtitleSmall}>
        INTELLECTUAL PROPERTY RIGHTS
      </p>
      <p className={css.info}>
        We are the owner or the licensee of all intellectual property rights in our site, and in the material published on it. Those works are protected by copyright laws and treaties around the world. All such rights are reserved.
      </p>
      <br />
      <p className={css.info}>
        You may print off one copy, and may download extracts, of any page(s) from our site for your personal reference and you may draw the attention of others within your organisation to material posted on our site.
      </p>
      <br />
      <p className={css.info}>
        You must not modify the paper or digital copies of any materials you have printed off or downloaded in any way, and you must not use any illustrations, photographs, video or audio sequences or any graphics separately from any accompanying text.
      </p>
      <br />
      <p className={css.info}>
        Our status (and that of any identified contributors) as the authors of material on our site must always be acknowledged. You must not use any part of the materials on our site for commercial purposes without obtaining a licence to do so from us or our licensors.
      </p>
      <br />
      <p className={css.info}>
        If you print off, copy or download any part of our site in breach of these terms of use, your right to use our site will cease immediately and you must, at our option, return or destroy any copies of the materials you have made.
      </p>

      <p className={css.subtitleSmall}>
        RELIANCE ON INFORMATION POSTED
      </p>
      <p className={css.info}>
        Commentary and other materials posted on our site are not intended to amount to advice on which reliance should be placed. We therefore disclaim all liability and responsibility arising from any reliance placed on such materials by any visitor to our site, or by anyone who may be informed of any of its contents.
      </p>

      <p className={css.subtitleSmall}>
        OUR SITE CHANGES REGULARLY
      </p>
      <p className={css.info}>
        We aim to update our site regularly, and may change the content at any time. If the need arises, we may suspend access to our site, or close it indefinitely. Any of the material on our site may be out of date at any given time, and we are under no obligation to update such material.
      </p>

      <p className={css.subtitleSmall}>
        OUR LIABILITY
      </p>
      <p className={css.info}>
        The material displayed on our site is provided without any guarantees, conditions or warranties as to its accuracy. To the extent permitted by law, we, other members of our group of companies and third parties connected to us hereby expressly exclude: All conditions, warranties and other terms which might otherwise be implied by statute, common law or the law of equity.
      </p>
      <br />
      <p className={css.info}>
        Any liability for any direct, indirect or consequential loss or damage incurred by any user in connection with our site or in connection with the use, inability to use, or results of the use of our site, any websites linked to it and any materials posted on it, including, without limitation any liability for:
      </p>
      <ul className={css.list}>
        <li>loss of income or revenue;</li>
        <li>loss of business;</li>
        <li>loss of profits or contracts;</li>
        <li>loss of anticipated savings;</li>
        <li>loss of data;</li>
        <li>loss of goodwill;</li>
        <li>wasted management or office time; and</li>
        <li>for any other loss or damage of any kind, however arising and whether caused by tort (including negligence), breach of contract or otherwise, even if foreseeable, provided that this condition shall not prevent claims for loss of or damage to your tangible property or any other claims for direct financial loss that are not excluded by any of the categories set out above.</li>
      </ul>
      <p className={css.info}>
        This does not affect our liability for death or personal injury arising from our negligence, nor to our liability for fraudulent misrepresentation or misrepresentation as to a fundamental matter, nor to any other liability which cannot be excluded or limited under applicable law.
      </p>

      <p className={css.subtitleSmall}>
        INFORMATION ABOUT YOU AND YOUR VISITS TO OUR SITE

      </p>
      <p className={css.info}>
        We process information about you in accordance with our {" "}
        <NamedLink name="PrivacyPolicyPage" >
          privacy policy
        </NamedLink>
        . By using our site, you consent to such processing and you warrant that all data provided by you is accurate.
      </p>

      <p className={css.subtitleSmall}>
        TRANSACTIONS CONCLUDED THROUGH OUR SITE
      </p>
      <p className={css.info}>
        Contracts for the supply of services formed through our site or as a result of visits made by you are governed by our HouseSit Match {" "}
        <NamedLink name="TermsAndConditions">
          terms and conditions of supply.
        </NamedLink>
      </p>

      <p className={css.subtitleSmall}>
        UPLOADING MATERIAL TO OUR SITE
      </p>
      <p className={css.info}>
        Whenever you make use of a feature that allows you to upload material to our site, or to make contact with other users of our site, you must comply with the content standards set out in our acceptable use policy. You warrant that any such contribution does comply with those standards, and you indemnify us for any breach of that warranty.
      </p>
      <br />
      <p className={css.info}>
        Any material you upload to our site will be considered non-confidential and non-proprietary, and we have the right to use, copy, distribute and disclose to third parties any such material for any purpose. We also have the right to disclose your identity to any third party who is claiming that any material posted or uploaded by you to our site constitutes a violation of their intellectual property rights, or of their right to privacy.
      </p>
      <br />
      <p className={css.info}>
        We will not be responsible, or liable to any third party, for the content or accuracy of any materials posted by you or any other user of our site.
      </p>
      <br />
      <p className={css.info}>
        We have the right to remove any material or posting you make on our site if, in our opinion, such material does not comply with the content standards set out in our acceptable use policy.
      </p>

      <p className={css.subtitleSmall}>
        VIRUSES, HACKING AND OTHER OFFENCES
      </p>
      <p className={css.info}>
        You must not misuse our site by knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful. You must not attempt to gain unauthorised access to our site, the server on which our site is stored or any server, computer or database connected to our site. You must not attack our site via a denial-of-service attack or a distributed denial-of service attack.
      </p>
      <br />
      <p className={css.info}>
        By breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990. We will report any such breach to the relevant law enforcement authorities and we will co-operate with those authorities by disclosing your identity to them. In the event of such a breach, your right to use our site will cease immediately.
      </p>
      <br />
      <p className={css.info}>
        We will not be liable for any loss or damage caused by a distributed denial-of-service attack, viruses or other technologically harmful material that may infect your computer equipment, computer programs, data or other proprietary material due to your use of our site or to your downloading of any material posted on it, or on any website linked to it.
      </p>

      <p className={css.subtitleSmall}>
        LINKING TO OUR SITE
      </p>
      <p className={css.info}>
        You may link to our home page, provided you do so in a way that is fair and legal and does not damage our reputation or take advantage of it, but you must not establish a link in such a way as to suggest any form of association, approval or endorsement on our part where none exists.
      </p>
      <br />
      <p className={css.info}>
        You must not establish a link from any website that is not owned by you.
      </p>
      <br />
      <p className={css.info}>
        Our site must not be framed on any other site, nor may you create a link to any part of our site other than the home page. We reserve the right to withdraw linking permission without notice. The website from which you are linking must comply in all respects with the content standards set out in our acceptable use policy.
      </p>
      <br />
      <p className={css.info}>
        If you wish to make any use of material on our site other than that set out above, please address your request to{" "}
        <a href="mailto: admin@housesitmatch.com">
          admin@housesitmatch.com
        </a>
      </p>

      <p className={css.subtitleSmall}>
        LINKS FROM OUR SITE
      </p>
      <p className={css.info}>
        Where our site contains links to other sites and resources provided by third parties, these links are provided for your information only. We have no control over the contents of those sites or resources, and accept no responsibility for them or for any loss or damage that may arise from your use of them.
      </p>

      <p className={css.subtitleSmall}>
        JURISDICTION AND APPLICABLE LAW
      </p>
      <p className={css.info}>
        The English courts will have exclusive jurisdiction over any claim arising from, or related to, a visit to our site although we retain the right to bring proceedings against you for breach of these conditions in your country of residence or any other relevant country.
      </p>
      <p className={css.info}>
        These terms of use and any dispute or claim arising out of or in connection with them or their subject matter or formation (including non-contractual disputes or claims) shall be governed by and construed in accordance with the law of England and Wales.
      </p>

      <p className={css.subtitleSmall}>
        TRADEMARKS
      </p>
      <div className={css.imageContainerHorizontal}>
        <img src={trademark} alt="trademark" />
      </div>
      <p className={css.info}>
        The logo is a UK registered trademark of HOUSESIT MATCH LIMITED. VARIATIONS
      </p>
      <p className={css.info}>
        We may revise these terms of use at any time by amending this page. You are expected to check this page from time to time to take notice of any changes we made, as they are binding on you. Some of the provisions contained in these terms of use may also be superseded by provisions or notices published elsewhere on our site.
      </p>

      <p className={css.subtitleSmall}>
        YOUR CONCERNS REGARDING OUR HOUSESIT MATCH TERMS OF USE
      </p>
      <p className={css.info}>
        If you have any concerns about material which appears on our site, please contact{" "}
        <a href="mailto: admin@housesitmatch.com">
          admin@housesitmatch.com
        </a>.
      </p>
      <p className={css.info}>
        Thank you for visiting our site.
      </p>
    </div>
  );
};

const TermsOfServicePage = props => {
  const config = useConfiguration();
  const intl = useIntl();

  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'TermsOfServicePage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({ id: 'TermsOfServicePage.schemaDescription' }, { marketplaceName });
  return (
    <Page
      title={schemaTitle}
      description={schemaDescription}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<SectionFooter />}
        mainColumnClassName={css.mainColumnClassName}
      >
        <TermsOfServiceContent />
      </LayoutSingleColumn>
    </Page >
  );
};

export default TermsOfServicePage;
